import { createGlobalStyle } from 'styled-components';

interface GlobalStyleProps {
  font?: string | null;
  transparent?: boolean;
}

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  ${({ font }) =>
    font &&
    font !== 'system-ui' &&
    `@font-face {
      font-family: PartnerFont;
      src: ${/^https?:\/\//.test(font) ? `url(${font})` : `local(${font})`};
    }`}

  html,
  body,
  .app,
  #app {
    height: 100%;
  }

  html {
    ${({ font }) =>
      font === 'system-ui' &&
      `
      @supports (font: -apple-system-body) and (-webkit-touch-callout: default) {
        font: -apple-system-body;
      }
    `}
    background-color: ${({ theme, transparent }) => (transparent ? 'inherit' : theme.backgroundColor)};
    ${({ theme, transparent }) =>
      theme.backgroundUrl &&
      !transparent &&
      `background-size: cover;
     background: url(${theme.backgroundUrl});`}
  }

  .container {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export default GlobalStyle;
